import { appConfig } from "../app.config";

export type SupportUrlParams = {
	locationId?: string | null;
	eventId?: string | null;
	ticketForm?: string;
	parkerId?: number | null;
};

export const buildSupportUrl = ({ locationId, eventId, ticketForm, parkerId }: SupportUrlParams = {}) => {
	const url = new URL(`${appConfig.HELP_CENTER_URL}/support/tickets/new`);
	url.searchParams.set("support_type", "parker");
	if (ticketForm) {
		url.searchParams.set("ticket_form", ticketForm);
	}
	if (locationId) {
		url.searchParams.set("location", locationId);
	} else if (eventId) {
		url.searchParams.set("event", eventId);
	}
	if (parkerId) {
		url.searchParams.set("parker", String(parkerId));
	}
	return url.toString();
};
